<img-with-fallback [src]="$node()?.imageUrl || null" class="w-full h-full">
	<div
		class="w-full h-full flex items-center justify-center"
		[class.bg-node-type-soft]="$useNodeColor()"
	>
		@if ($node(); as node) {
			@if (node.emoji) {
				{{ node.emoji }}
			} @else {
				<i [nodeTypeIcon]="node.nodeType"></i>
			}
		}
	</div>
</img-with-fallback>
